import { Outlet } from "react-router-dom";
import { useParams } from "react-router-dom";

import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar";

const AppLayout = () => {
  const { projectId } = useParams();

  return (
    <>
      <Header />
      <div style={{ display: "flex" }}>
        {projectId && <Sidebar />}
        <div style={{ flex: 1, overflowY: "auto", margin: "20px" }}>
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AppLayout;
